function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGit = function SvgGit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F05133",
    fillRule: "nonzero",
    d: "M31.4 14.57L17.42.6c-.8-.8-2.1-.8-2.9 0l-2.9 2.9 3.67 3.7c.83-.3 1.82-.1 2.5.57.7.7.87 1.68.6 2.54l3.53 3.56c.85-.3 1.84-.1 2.53.58.96.96.96 2.5 0 3.47-.96.97-2.5.97-3.47 0-.73-.7-.9-1.77-.54-2.66l-3.3-3.3v8.7c.22.12.44.27.64.46.96.95.96 2.5 0 3.46-.95.96-2.5.96-3.46 0s-.96-2.5 0-3.46c.24-.24.5-.42.8-.54v-8.8c-.3-.1-.56-.28-.8-.52-.73-.73-.9-1.8-.53-2.68l-3.6-3.63L.6 14.5c-.8.8-.8 2.12 0 2.92L14.58 31.4c.8.8 2.1.8 2.9 0L31.4 17.5c.8-.8.8-2.12 0-2.92",
    style: {
      fill: "#F05133"
    }
  })));
};
export default SvgGit;